import { initialState } from './initial';
import { actionTypes } from './actions';

export function reducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.ACTION_PROCESSING:
      return {
        ...state,
        actionProcessing: action.payload,
      };

    case actionTypes.SET_POINTS_DATA:
      return {
        ...state,
        points: action.payload,
      };

    default:
      return state;
  }
}
